import React, { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import validate from 'validate.js';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import moment from 'moment';
import { Button, TextField, Card, Grid, CardHeader, CardContent, Tabs, Tab, Typography, Box, Divider } from '@mui/material';
import _ from 'underscore';
import { SelectField } from 'components';
import DatePicker from 'components/DatePicker/DatePicker';
import DateTimePicker from 'components/DatePicker/DateTimePicker';
import TimePicker from 'components/DatePicker/TimePicker';
import {
	SetFormState,
	GetAutocompleteFields,
	ToggleAttachFileSiteTrackerDialog,
	DownloadAttachments
} from '../../../../actions/SiteTrackerActions';
import SiteTrackerComments from './SiteTrackerComments';
import TeamOne from './Teams/TeamOne';
import TeamTwo from './Teams/TeamTwo';

const schema = {
	siteId: {
		presence: { allowEmpty: false, message: 'is required' }
	},
	// date: {
	// 	presence: { allowEmpty: false, message: 'is required' }
	// },
	// status: {
	// 	presence: { allowEmpty: false, message: 'is required' }
	// }
};

const useStyles = makeStyles(theme => ({
	root: {},
	fields: {
		margin: theme.spacing(-1),
		display: 'flex',
		flexWrap: 'wrap',
		'& > *': {
			flexGrow: 1,
			margin: theme.spacing(1)
		}
	},
	submitButton: {
		marginTop: theme.spacing(2),
		width: '100%'
	},
	divider: {
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1)
	}
}));

const SiteTrackerDialogForm = (props) => {
	const { className, tableId, ...rest } = props;
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector(state => state.siteTrackerReducer.formState);
	const dropdowns = useSelector(state => state.siteTrackerReducer.dropdowns);
	const autocompleteFields = useSelector(state => state.siteTrackerReducer.autocompleteFields);
	const comments = useSelector(state => state.siteTrackerReducer.comments);
	const userId = useSelector(state => state.session.user.id);
	const userRole = useSelector(state => state.session.user.role);
	const _hasError = field => !!(formState.touched[field] && formState.errors[field]);
	const [statusClosedDate, setStatusClosedDate] = React.useState('');
	const attachments = useSelector((state) => state.siteTrackerReducer.attachments);

	const _handleChange = event => {
		// if (event.target.name === 'siteId') {
		// 	dispatch(GetAutocompleteFields(event.target.value));
		// }

		// if (event.target.name === 'status') {
		// 	if (event.target.value === '8') {
		// 		setStatusClosedDate('');
		// 	} else if (event.target.value === '9') {
		// 		setStatusClosedDate(moment().format('YYYY-MM-DD HH:mm:ss'));
		// 	}
		// }

		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]:
					event.target.type === 'checkbox'
						? event.target.checked
						: event.target.value
			},
			touched: {
				...formState.touched,
				[event.target.name]: true
			}
		});
	};

	const _handleDateChange = (value, name, type = 'date') => {
		let formattedValue = null;

		if (value) {
			if (type === 'date') {
				formattedValue = value.startOf('day').format('YYYY-MM-DD');
			} else {
				formattedValue = value.format('YYYY-MM-DD HH:mm:ss');
			}
		}

		setFormState({
			...formState,
			values: {
				...formState.values,
				[name]: formattedValue
			},
			touched: {
				...formState.touched,
				[name]: true
			}
		});

		rulesManagement(name, value);
	};

	const [disableField, setDisableField] = useState(true);

	useEffect(() => {

		if (userRole === "Administrator" || userRole === "Manager") {
			setDisableField(false);
		} else {
			setDisableField(true);
		}
	}, []);

	useEffect(() => {
		const newTouched = {};

		if (formState.values.submit) {
			_.each(_.keys(schema), item => {
				newTouched[item] = true;
			});
		}

		const errors = validate(formState.values, schema, {
			fullMessages: false
		});

		setFormState({
			...formState,
			isValid: !errors,
			errors: errors || {},
			touched: {
				...formState.touched,
				...newTouched
			}
		});

		if (
			formState.values.closedDate !== undefined
			&& formState.values.closedDate !== null
			&& formState.values.globalStatus === 'Closed'
		) {
			setStatusClosedDate(
				moment(formState.values.closedDate).format(
					'DD/MM/YYYY HH:mm:ss'
				)
			);
		}
	}, [formState.values]);

	useMemo(() => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				jvcoId: autocompleteFields.jvcoId,
				polygon: autocompleteFields.polygon
			}
			// touched: {
			// 	...formState.touched,
			// 	jvcoId: true,
			// },
		});
	}, [autocompleteFields]);

	const rulesManagement = (fieldName, value) => {
		const datetimeNow = moment().format('YYYY-MM-DD HH:mm:ss');

		if (fieldName === 'mocnActivationDateA') {
			setFormState({
				...formState,
				values: {
					...formState.values,
					[fieldName]: value,
					kpisMonitorVmo26hDate: datetimeNow
				},
				touched: {
					...formState.touched,
					[fieldName]: true,
					kpisMonitorVmo26hDate: true
				}
			});
		}
	};

	const [tab, setTab] = useState('teamOne');

	const handleTabsChange = (event, value) => {
		setTab(value);
	};

	const tabs = [
		{ value: 'teamOne', label: 'Performance' },
		{ value: 'teamTwo', label: 'RAN' }
	];

	return (
		<div className={classes.fields}>
			<Grid container spacing={2}>
				<Grid item md={12} xs={12}>
					<Card style={{ backgroundColor: '#F2F2F2' }}>
						<CardHeader title="Site Information" style={{ paddingBottom: 0 }} />
						<CardContent>
							<Grid container spacing={2}>
								<Grid item md={2} xs={2}>
									<TextField
										id="siteId"
										name="siteId"
										label="Site Id"
										variant="outlined"
										error={_hasError('siteId')}
										fullWidth
										helperText={
											_hasError('siteId')
												? formState.errors.siteId[0]
												: null
										}
										value={formState.values.siteId || ''}
										onChange={_handleChange}
										disabled={tableId !== undefined}
										sx={{
											'& .MuiInputBase-input': {
												backgroundColor: 'white',
												'&.Mui-disabled': {
													color: 'dimGray',
													WebkitTextFillColor: 'dimGray'
												}
											},
										}}
									/>
								</Grid>
								<Grid item md={3} xs={3}>
									<SelectField
										id="clusterName"
										name="clusterName"
										hintText="Cluster Name"
										defaultValue=""
										menuItems={
											(dropdowns && dropdowns.clusterName) || []
										}
										value={formState.values.clusterName}
										onChange={_handleChange}
										error={
											_hasError('clusterName')
												? formState.errors.clusterName[0]
												: null
										}
										sx={{
											'& .MuiInputBase-input': {
												backgroundColor: 'white',
												'&.Mui-disabled': {
													color: 'dimGray',
													WebkitTextFillColor: 'dimGray'
												}
											},
										}}
										disabled={disableField}
									/>
								</Grid>
								<Grid item md={2} xs={2}>
									<SelectField
										id="mandatoryOptional"
										name="mandatoryOptional"
										hintText="Mandatory/Optional"
										defaultValue=""
										menuItems={
											(dropdowns && dropdowns.mandatoryOptional) || []
										}
										value={formState.values.mandatoryOptional}
										onChange={_handleChange}
										error={
											_hasError('mandatoryOptional')
												? formState.errors.mandatoryOptional[0]
												: null
										}
										sx={{
											'& .MuiInputBase-input': {
												backgroundColor: 'white',
												'&.Mui-disabled': {
													color: 'dimGray',
													WebkitTextFillColor: 'dimGray'
												}
											},
										}}
										disabled={disableField}
									/>
								</Grid>
								<Grid item md={3} xs={3}>
									<SelectField
										id="clusterUseCase"
										name="clusterUseCase"
										hintText="Cluster Use Case"
										defaultValue=""
										menuItems={
											(dropdowns && dropdowns.clusterUseCase) || []
										}
										value={formState.values.clusterUseCase}
										onChange={_handleChange}
										error={
											_hasError('clusterUseCase')
												? formState.errors.clusterUseCase[0]
												: null
										}
										sx={{
											'& .MuiInputBase-input': {
												backgroundColor: 'white',
												'&.Mui-disabled': {
													color: 'dimGray',
													WebkitTextFillColor: 'dimGray'
												}
											},
										}}
										disabled={disableField}
									/>
								</Grid>
								<Grid item md={2} xs={2}>
									<SelectField
										id="benefit"
										name="benefit"
										hintText="Benefit"
										defaultValue=""
										menuItems={
											(dropdowns && dropdowns.benefit) || []
										}
										value={formState.values.benefit}
										onChange={_handleChange}
										error={
											_hasError('benefit')
												? formState.errors.benefit[0]
												: null
										}
										sx={{
											'& .MuiInputBase-input': {
												backgroundColor: 'white',
												'&.Mui-disabled': {
													color: 'dimGray',
													WebkitTextFillColor: 'dimGray'
												}
											},
										}}
										disabled={disableField}
									/>
								</Grid>
							</Grid>
							<br />
							{/* New line */}
							<Grid container spacing={2}>
								<Grid item md={2} xs={2}>
									<SelectField
										id="eMocnType"
										name="eMocnType"
										hintText="E-MOCN Type"
										defaultValue=""
										menuItems={
											(dropdowns && dropdowns.eMocnType) || []
										}
										value={formState.values.eMocnType}
										onChange={_handleChange}
										error={
											_hasError('eMocnType')
												? formState.errors.eMocnType[0]
												: null
										}
										sx={{
											'& .MuiInputBase-input': {
												backgroundColor: 'white',
												'&.Mui-disabled': {
													color: 'dimGray',
													WebkitTextFillColor: 'dimGray'
												}
											},
										}}
										disabled={disableField}
									/>
								</Grid>
								<Grid item md={3} xs={3}>
									<TextField
										id="eMocnSubType"
										name="eMocnSubType"
										label="E-MOCN Sub-Type"
										variant="outlined"
										error={_hasError('eMocnSubType')}
										fullWidth
										helperText={
											_hasError('eMocnSubType')
												? formState.errors.eMocnSubType[0]
												: null
										}
										value={formState.values.eMocnSubType || ''}
										onChange={_handleChange}
										sx={{
											'& .MuiInputBase-input': {
												backgroundColor: 'white',
												'&.Mui-disabled': {
													color: 'dimGray',
													WebkitTextFillColor: 'dimGray'
												}
											},
										}}
										disabled={disableField}
									/>
								</Grid>
								<Grid item md={3} xs={3}>
									<SelectField
										id="scripts"
										name="scripts"
										hintText="Script"
										defaultValue=""
										menuItems={
											(dropdowns && dropdowns.script) || []
										}
										value={formState.values.scripts}
										onChange={_handleChange}
										error={
											_hasError('script')
												? formState.errors.script[0]
												: null
										}
										sx={{
											'& .MuiInputBase-input': {
												backgroundColor: 'white',
												'&.Mui-disabled': {
													color: 'dimGray',
													WebkitTextFillColor: 'dimGray'
												}
											},
										}}
										isMultiSelect
										disabled={disableField}
									/>
								</Grid>
								<Grid item md={1} xs={1}>
									<TextField
										id="_3gsdPriority"
										name="_3gsdPriority"
										label="3GSD Priority"
										variant="outlined"
										error={_hasError('_3gsdPriority')}
										fullWidth
										helperText={
											_hasError('_3gsdPriority')
												? formState.errors._3gsdPriority[0]
												: null
										}
										value={formState.values._3gsdPriority || ''}
										onChange={_handleChange}
										sx={{
											'& .MuiInputBase-input': {
												backgroundColor: 'white',
												'&.Mui-disabled': {
													color: 'dimGray',
													WebkitTextFillColor: 'dimGray'
												}
											},
										}}
										disabled={disableField}
									/>
								</Grid>
								<Grid item md={3} xs={3}>
									<SelectField
										id="vendor"
										name="vendor"
										hintText="Vendor"
										defaultValue=""
										menuItems={
											(dropdowns && dropdowns.vendor) || []
										}
										value={formState.values.vendor}
										onChange={_handleChange}
										error={
											_hasError('vendor')
												? formState.errors.vendor[0]
												: null
										}
										sx={{
											'& .MuiInputBase-input': {
												backgroundColor: 'white',
												'&.Mui-disabled': {
													color: 'dimGray',
													WebkitTextFillColor: 'dimGray'
												}
											},
										}}
										disabled={disableField}
									/>
								</Grid>
							</Grid>
							<br />
							{/* New line */}
							<Grid container spacing={2}>
								<Grid item md={2} xs={2}>
									<SelectField
										id="operator"
										name="operator"
										hintText="Operator"
										defaultValue=""
										menuItems={
											(dropdowns && dropdowns.operator) || []
										}
										value={formState.values.operator}
										onChange={_handleChange}
										error={
											_hasError('operator')
												? formState.errors.operator[0]
												: null
										}
										sx={{
											'& .MuiInputBase-input': {
												backgroundColor: 'white',
												'&.Mui-disabled': {
													color: 'dimGray',
													WebkitTextFillColor: 'dimGray'
												}
											},
										}}
										disabled={disableField}
									/>
								</Grid>
								<Grid item md={2} xs={2}>
									<SelectField
										id="host"
										name="host"
										hintText="Host"
										defaultValue=""
										menuItems={
											(dropdowns && dropdowns.host) || []
										}
										value={formState.values.host}
										onChange={_handleChange}
										error={
											_hasError('host')
												? formState.errors.host[0]
												: null
										}
										sx={{
											'& .MuiInputBase-input': {
												backgroundColor: 'white',
												'&.Mui-disabled': {
													color: 'dimGray',
													WebkitTextFillColor: 'dimGray'
												}
											},
										}}
										disabled={disableField}
									/>
								</Grid>
								<Grid item md={2} xs={2}>
									<TextField
										id="jvMbnlId"
										name="jvMbnlId"
										label="JV/MBNL ID"
										variant="outlined"
										error={_hasError('jvMbnlId')}
										fullWidth
										helperText={
											_hasError('jvMbnlId')
												? formState.errors.jvMbnlId[0]
												: null
										}
										value={formState.values.jvMbnlId || ''}
										onChange={_handleChange}
										sx={{
											'& .MuiInputBase-input': {
												backgroundColor: 'white',
												'&.Mui-disabled': {
													color: 'dimGray',
													WebkitTextFillColor: 'dimGray'
												}
											},
										}}
										disabled={disableField}
									/>
								</Grid>
								<Grid item md={2} xs={2}>
									<TextField
										id="vmo2Csr"
										name="vmo2Csr"
										label="VMO2 CSR"
										variant="outlined"
										error={_hasError('vmo2Csr')}
										fullWidth
										helperText={
											_hasError('vmo2Csr')
												? formState.errors.vmo2Csr[0]
												: null
										}
										value={formState.values.vmo2Csr || ''}
										onChange={_handleChange}
										sx={{
											'& .MuiInputBase-input': {
												backgroundColor: 'white',
												'&.Mui-disabled': {
													color: 'dimGray',
													WebkitTextFillColor: 'dimGray'
												}
											},
										}}
										disabled={disableField}
									/>
								</Grid>
								<Grid item md={2} xs={2}>
									<SelectField
										id="beacon"
										name="beacon"
										hintText="Beacon"
										defaultValue=""
										menuItems={
											(dropdowns && dropdowns.beacon) || []
										}
										value={formState.values.beacon}
										onChange={_handleChange}
										error={
											_hasError('beacon')
												? formState.errors.beacon[0]
												: null
										}
										sx={{
											'& .MuiInputBase-input': {
												backgroundColor: 'white',
												'&.Mui-disabled': {
													color: 'dimGray',
													WebkitTextFillColor: 'dimGray'
												}
											},
										}}
										disabled={disableField}
									/>
								</Grid>
								<Grid item md={2} xs={2}>
									<SelectField
										id="unwind"
										name="unwind"
										hintText="Unwind"
										defaultValue=""
										menuItems={
											(dropdowns && dropdowns.unwind) || []
										}
										value={formState.values.unwind}
										onChange={_handleChange}
										error={
											_hasError('unwind')
												? formState.errors.unwind[0]
												: null
										}
										sx={{
											'& .MuiInputBase-input': {
												backgroundColor: 'white',
												'&.Mui-disabled': {
													color: 'dimGray',
													WebkitTextFillColor: 'dimGray'
												}
											},
										}}
										disabled={disableField}
									/>
								</Grid>
							</Grid>
						</CardContent>
					</Card>
				</Grid>
			</Grid>
			<Grid container spacing={2}>
				<Grid item md={12} xs={12}>
					<Card style={{ backgroundColor: '#F2F2F2' }}>
						<CardHeader title="Additional Information" style={{ paddingBottom: 0 }} />
						<CardContent>
							<Grid container spacing={2}>
								<Grid item md={2} xs={2}>
									<SelectField
										id="mocnCategoryPlannedForTrial"
										name="mocnCategoryPlannedForTrial"
										hintText="MOCN Category Planned for Trial"
										defaultValue=""
										menuItems={
											(dropdowns && dropdowns.mocnCategoryPlannedForTrial) || []
										}
										value={formState.values.mocnCategoryPlannedForTrial}
										onChange={_handleChange}
										error={
											_hasError('mocnCategoryPlannedForTrial')
												? formState.errors.mocnCategoryPlannedForTrial[0]
												: null
										}
										sx={{
											'& .MuiInputBase-input': {
												backgroundColor: 'white',
												'&.Mui-disabled': {
													color: 'dimGray',
													WebkitTextFillColor: 'dimGray'
												}
											},
										}}
										disabled={disableField}
									/>
								</Grid>
								{/* <Grid item md={2} xs={2}>
									<SelectField
										id="mergeCoStatus"
										name="mergeCoStatus"
										hintText="MergeCo - Status"
										defaultValue=""
										menuItems={
											(dropdowns && dropdowns.mergeCoStatus) || []
										}
										value={formState.values.mergeCoStatus}
										onChange={_handleChange}
										error={
											_hasError('mergeCoStatus')
												? formState.errors.mergeCoStatus[0]
												: null
										}
										sx={{
											'& .MuiInputBase-input': {
												backgroundColor: 'white',
												'&.Mui-disabled': {
													color: 'dimGray',
													WebkitTextFillColor: 'dimGray'
												}
											},
										}}
										disabled={disableField}
									/>
								</Grid> */}
								{/* <Grid item md={2} xs={2}>
									<TextField
										id="mergeCoPlan"
										name="mergeCoPlan"
										label="MergeCo Plan"
										variant="outlined"
										error={_hasError('mergeCoPlan')}
										fullWidth
										helperText={
											_hasError('mergeCoPlan')
												? formState.errors.mergeCoPlan[0]
												: null
										}
										value={formState.values.mergeCoPlan || ''}
										onChange={_handleChange}
										sx={{
											'& .MuiInputBase-input': {
												backgroundColor: 'white',
												'&.Mui-disabled': {
													color: 'dimGray',
													WebkitTextFillColor: 'dimGray'
												}
											},
										}}
										disabled={disableField}
									/>
								</Grid>
								<Grid item md={2} xs={2}>
									<SelectField
										id="highMedLowConfig"
										name="highMedLowConfig"
										hintText="High/Med/Low Config"
										defaultValue=""
										menuItems={
											(dropdowns && dropdowns.highMedLowConfig) || []
										}
										value={formState.values.highMedLowConfig}
										onChange={_handleChange}
										error={
											_hasError('highMedLowConfig')
												? formState.errors.highMedLowConfig[0]
												: null
										}
										sx={{
											'& .MuiInputBase-input': {
												backgroundColor: 'white',
												'&.Mui-disabled': {
													color: 'dimGray',
													WebkitTextFillColor: 'dimGray'
												}
											},
										}}
										disabled={disableField}
									/>
								</Grid> */}
								<Grid item md={2} xs={2}>
									<TextField
										id="pacInfo"
										name="pacInfo"
										label="PAC Info"
										variant="outlined"
										error={_hasError('pacInfo')}
										fullWidth
										helperText={
											_hasError('pacInfo')
												? formState.errors.pacInfo[0]
												: null
										}
										value={formState.values.pacInfo || ''}
										onChange={_handleChange}
										sx={{
											'& .MuiInputBase-input': {
												backgroundColor: 'white',
												'&.Mui-disabled': {
													color: 'dimGray',
													WebkitTextFillColor: 'dimGray'
												}
											},
										}}
										disabled
									/>
								</Grid>
								<Grid item md={2} xs={2}>
									<DatePicker
										id="pacDate"
										name="pacDate"
										label="PAC Date"
										value={formState.values.pacDate}
										onChange={value => _handleDateChange(value, 'pacDate')}
										error={
											_hasError('pacDate')
												? formState.errors.pacDate[0]
												: null
										}
										helperText={
											_hasError('pacDate')
												? formState.errors.pacDate[0]
												: null
										}
										format="DD/MM/YYYY"
										disabled
									/>
								</Grid>
								<Grid item md={2} xs={2}>
									<DatePicker
										id="ms112Date"
										name="ms112Date"
										label="MS 11.2 Date"
										value={formState.values.ms112Date}
										onChange={value => _handleDateChange(value, 'ms112Date')}
										error={
											_hasError('ms112Date')
												? formState.errors.ms112Date[0]
												: null
										}
										helperText={
											_hasError('ms112Date')
												? formState.errors.ms112Date[0]
												: null
										}
										format="DD-MM-YYYY"
									/>
								</Grid>
								<Grid item md={2} xs={2}>
									<DatePicker
										id="ms127Date"
										name="ms127Date"
										label="MS 12.7 Date"
										value={formState.values.ms127Date}
										onChange={value => _handleDateChange(value, 'ms127Date')}
										error={
											_hasError('ms127Date')
												? formState.errors.ms127Date[0]
												: null
										}
										helperText={
											_hasError('ms127Date')
												? formState.errors.ms127Date[0]
												: null
										}
										format="DD-MM-YYYY"
									/>
								</Grid>
								<Grid item md={2} xs={2}>
									<SelectField
										id="ms127Status"
										name="ms127Status"
										hintText="MS 12.7 Status"
										defaultValue=""
										menuItems={
											(dropdowns && dropdowns.ms127Status) || []
										}
										value={formState.values.ms127Status}
										onChange={_handleChange}
										error={
											_hasError('ms127Status')
												? formState.errors.ms127Status[0]
												: null
										}
										sx={{
											'& .MuiInputBase-input': {
												backgroundColor: 'white',
												'&.Mui-disabled': {
													color: 'dimGray',
													WebkitTextFillColor: 'dimGray'
												}
											},
										}}
										disabled={disableField}
									/>
								</Grid>
							</Grid>
						</CardContent>
					</Card>
				</Grid>
			</Grid>
			<Grid container spacing={2}>
				<Grid item md={12} xs={12}>
					<Card style={{ backgroundColor: '#F2F2F2' }}>
						<CardHeader title="Schedule Information" style={{ paddingBottom: 0 }} />
						<CardContent>
							<Grid container spacing={2}>
								<Grid item md={2} xs={2}>
									<DatePicker
										id="mocnActivationDateF"
										name="mocnActivationDateF"
										label="MOCN Activation date (F)"
										value={formState.values.mocnActivationDateF}
										onChange={value => _handleDateChange(value, 'mocnActivationDateF')}
										error={
											_hasError('mocnActivationDateF')
												? formState.errors.mocnActivationDateF[0]
												: null
										}
										helperText={
											_hasError('mocnActivationDateF')
												? formState.errors.mocnActivationDateF[0]
												: null
										}
										format="DD/MM/YYYY"
										disabled={disableField}
									/>
								</Grid>
								<Grid item md={2} xs={2}>
									<DatePicker
										id="mocnActivationDateA"
										name="mocnActivationDateA"
										label="MOCN Activation date (A)"
										value={formState.values.mocnActivationDateA}
										onChange={value => _handleDateChange(value, 'mocnActivationDateA')}
										error={
											_hasError('mocnActivationDateA')
												? formState.errors.mocnActivationDateA[0]
												: null
										}
										helperText={
											_hasError('mocnActivationDateA')
												? formState.errors.mocnActivationDateA[0]
												: null
										}
										format="DD/MM/YYYY"
										disabled={disableField}
									/>
								</Grid>
								<Grid item md={2} xs={2}>
									<SelectField
										id="mocnActivationStatus"
										name="mocnActivationStatus"
										hintText="MOCN Activation Status"
										defaultValue=""
										menuItems={
											(dropdowns && dropdowns.mocnActivationStatus) || []
										}
										value={formState.values.mocnActivationStatus}
										onChange={_handleChange}
										error={
											_hasError('mocnActivationStatus')
												? formState.errors.mocnActivationStatus[0]
												: null
										}
										sx={{
											'& .MuiInputBase-input': {
												backgroundColor: 'white',
												'&.Mui-disabled': {
													color: 'dimGray',
													WebkitTextFillColor: 'dimGray'
												}
											},
										}}
										disabled={disableField}
									/>
								</Grid>
								{/* <Grid item md={6} xs={6}>
									<TextField
										id="mocnActivationComments"
										name="mocnActivationComments"
										label="MOCN Activation Comments"
										variant="outlined"
										error={_hasError('mocnActivationComments')}
										fullWidth
										helperText={
											_hasError('mocnActivationComments')
												? formState.errors.mocnActivationComments[0]
												: null
										}
										value={formState.values.mocnActivationComments || ''}
										onChange={_handleChange}
										sx={{
											'& .MuiInputBase-input': {
												backgroundColor: 'white',
												'&.Mui-disabled': {
													color: 'dimGray',
													WebkitTextFillColor: 'dimGray'
												}
											},
										}}
										disabled={disableField}
									/>
								</Grid> */}
								<Grid item md={12} xs={12}>
									<SiteTrackerComments title="MOCN Activation Comments" tableId={tableId} comments={comments.mocnActivationComments} disabled={disableField} />

								</Grid>
							</Grid>
						</CardContent>
					</Card>
				</Grid>
			</Grid>
			{/* New row */}
			<Grid container spacing={2}>
				<Grid item md={12} xs={12} hidden={tableId === undefined}>
					<Card style={{ backgroundColor: '#F2F2F2' }}>
						<CardHeader title="Teams" style={{ paddingBottom: 0 }} />
						<CardContent>

							<Tabs
								className={classes.tabs}
								onChange={handleTabsChange}
								scrollButtons="auto"
								value={tab}
								variant="scrollable"
							>
								{tabs.map((t) => (
									<Tab key={t.value} label={t.label} value={t.value} />
								))}
							</Tabs>
							<Divider className={classes.divider} />
							<div className={classes.content}>
								{tab === 'teamOne' && <TeamOne tableId={tableId} comments={comments} attachments={attachments} />}
								{tab === 'teamTwo' && <TeamTwo tableId={tableId} comments={comments} attachments={attachments} />}
								{/* {tab === 'three' && <TeamThree tableId={tableId} comments={comments} attachments={attachments} />} */}
							</div>
						</CardContent>
					</Card>
				</Grid>
			</Grid>
		</div >
	);
};

SiteTrackerDialogForm.propTypes = {
	className: PropTypes.string,
	tableId: PropTypes.number
};

export default SiteTrackerDialogForm;
